<script setup>
    import { useSqlEditorStore } from '@/stores/sqlEditorStore.ts';
    import { getCodeLinkByB64Id } from '@/shared/helpers/routing';
    import { encodeIdBase64 } from '@/shared/helpers/utils';

    const store = useSqlEditorStore();

    function codeLinkFromDbId(id) {
        return getCodeLinkByB64Id(encodeIdBase64('Code', id));
    }
</script>

<template>
    <div
        v-if="store.result"
        class="query-results">
        <p class="is-italic mb-1 has-text-right">
            {{ store.result.length }} record{{ store.result.length !== 1 ? 's' : '' }}
        </p>
        <b-table
            :key="store.resultId"
            striped
            narrowed
            paginated
            :per-page="store.loadedQueryPageSize || 20"
            :data="store.result">
            <template
                v-for="(column, idx) in store.resultColumns"
                :key="idx">
                <b-table-column
                    v-slot="props"
                    :field="column.field"
                    :sortable="column.sortable"
                    :label="column.label">
                    <template v-if="column.field === 'Id' || column.field.endsWith('_ID')">
                        <router-link :to="codeLinkFromDbId(props.row[column.field])">
                            {{ props.row[column.field] }}
                        </router-link>
                    </template>
                    <template v-else-if="props.row[column.field] === null">
                        <span class="has-text-grey-light">null</span>
                    </template>
                    <template v-else-if="props.row[column.field].substring && props.row[column.field].substring(0, 8) === 'https://'">
                        <a :href="props.row[column.field]">{{ props.row[column.field] }}</a>
                    </template>
                    <template v-else>
                        <span
                            class="keep-spaces"
                            v-text="props.row[column.field]" />
                    </template>
                </b-table-column>
            </template>
        </b-table>
    </div>
</template>

<style scoped>
.query-results {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  width: 72vw;
  padding: 4px;
}
.keep-spaces {
    white-space: pre;
}
</style>
